namespace('compass.hotel');

compass.require('compass.util.validate');

compass.hotel.CancelRoomWidget = compass.defineWidget(function CancelRoomWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _cf = _settings.currencyFormatter;
	var _WUID = _settings.WUID;
	var _labels = _settings.labels;
	var _reason, _notes;
	var _validator = _settings.validator;
    if (!_validator){
        _validator = new compass.validator({
        widget: me,
        onValid: function (field, opts) {
            field.removeClass("invalid");
        },
        onInvalid: function (field, opts) {
            field.addClass("invalid");
        }
    });

    }

	me.setupControls = function() { };
	var _setupControls = me.setupControls;

	me.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(me.drawCancelForm(_settings.hotelPenalties));

		_setupControls();
	};
	var _render = me.render;
	
	me.getValues = function () {
		var vals = {
			'reason': _reason.val(),
			'notes': _notes.val()
		};

		return vals;
	};

	me.drawCancelForm = function(hotelPenalties) {
		var d = _d;
		return d.div({className:'cancelWidgetWrapper'},
				_settings.hideHeader ? '' : d.div({className:'cancelWidgetHeader'},'Cancel This Reservation'),
				me.drawCancelReasons(_settings.cancelReasons),
				me.drawCancelComments(),
				me.drawCancellationCheckbox(),
				me.drawCancelButton(),
				d.div({className: 'clear'})
			);
	};

	me.drawCancelReasons = function(cancelReasonsArr) {
		var d = _d;
		var reasons = _.union([{lookup_id : -1, value : 'Select a reason'}], _settings.cancelReasons);
		_reason = d.select(_.map(reasons, function (reason) {
				return d.option({
					value: reason.lookup_id
				}, reason.value);
			})).data("hint", _labels.reasons.hint)
			.change(function() {
					me.trigger("CancelRoomWidget.cancelReasonsChanged");
			});

		if (_validator) {
			_validator.addFields(_reason, function (e) {
				return e.val() === '-1' ? _validator.INVALID : _validator.VALID;
			}, { });
		}

		return d.div({
			className: 'reasons'
		}, d.label(_labels.reasons.label),
			_reason
		);
	};

	me.drawCancelComments = function() {
		var d = _d;
		_notes = d.textarea().data("hint", _labels.notes.hint);

		return d.div({
			className: 'notes'
		}, d.label(_labels.notes.label),
			_notes
		);
	};

	me.drawCancelButton = function () {

		var respondToCancelClick = function(evt, arcticEventToTrigger){
			var button = $(evt.target);
			if(button.hasClass('disabled')) { return; }
			var vh = compass.util.validationHelper(_validator);
			vh.attachHints();
			me.trigger(arcticEventToTrigger, me.getValues());
			button.addClass('disabled');
		};

		var d = _d;
		if (_settings.showSecondaryButton) {
			return [
				d.button({ className: 'cancelButton button' }, "Update Quantity").activate(function (evt) {
					me.trigger('CancelRoomWidget.cancelFeeCheckboxChanged');
					respondToCancelClick(evt, 'CancelRoomWidget.Cancel');
				}),
				d.button({ className: 'cancelAllButton secondaryButton'}, 'Cancel All Rooms').activate(function (evt) {
					me.trigger('CancelRoomWidget.cancelFeeCheckboxChanged');
					respondToCancelClick(evt, 'CancelRoomWidget.CancelAll');
				}),
			];
		} else {
			return d.button({ className: 'cancelButton button' }, "Cancel reservation").activate(function (evt) {
				me.trigger('CancelRoomWidget.cancelFeeCheckboxChanged');
				respondToCancelClick(evt, 'CancelRoomWidget.Cancel');
			});
		}
	};

	me.drawCancellationCheckbox = function() {
		var d = _d;
		if (_settings.cancelFee != '0') {
				return d.div({ className: 'cancelFeeContainer'}, 
					d.input({ className: 'cancelFeeCheckbox', type: 'checkbox'}).change(function() {
						me.trigger("CancelRoomWidget.cancelFeeCheckboxChanged");
					}),
					d.div({ className: 'cancelFeeText'}, _labels.checkbox.label + _cf(_settings.cancelFee))
				);
			}
		
		if (_settings.hasActiveCancelFee) {
			return d.div({ className: 'cancelFeeContainer'},
				d.input({ className: 'cancelFeeCheckbox', type: 'checkbox'}).change(function() {
					me.trigger("CancelRoomWidget.cancelFeeCheckboxChanged");
				}),
				d.div({ className: 'cancelFeeText'}, _labels.checkbox.batchModifyLabel), 
				_d.a({className: 'hotelPolicies'}, 'View Hotel Policies').activate(function() {
					me.trigger('CancelRoomWidget.showPolicies', {
						blockedRoomIds: _settings.blockedRoomIds
					});
				})
			);
		}
		
		return null;
	};

	me.getCancelButton = function() {
		return me.find('.cancelButton');
	};

	me.getCheckbox = function() {
		return me.find('.cancelFeeCheckbox');
	};

	var _d = jQuery.dom.getContext(me);
}, {
	WUID : 'defaultCancelRoomWidgetWUID',
	widgetName : 'CancelRoomWidget',
	cancelPenalties : [],
	cancelFee : 0,
	cancelReasons : [],
	showSecondaryButton: false,
	showPolicies: false,
	labels: {
		reasons: {
			label: "Cancelled because",
			hint: 'Reason is required'
		},
		notes: {
			label: 'Any comments to help us out?',
			hint: ''
		},
		checkbox: {
			label: 'I understand that I am subject to a cancellation fee of ',
			batchModifyLabel: 'I understand that I may be subject to a cancellation fee. &nbsp;'
		}
	}
});
